// Équivalents des constantes définies en haut du script R

export const ANNEES_ANCRAGE = [2020,2025, 2030, 2035, 2040, 2045, 2050];

export const POLITIQUES = [
  { value: "stricte_1_5ans", label: "Rare" },
  { value: "stricte_2_10ans", label: "Faible" },
  { value: "stricte_3_15ans", label: "Moyenne" },
  { value: "stricte_4_20ans", label: "Stricte" },
  { value: "stricte_5_25ans", label: "Radicale" },
];

function hexMix(hex1, hex2, t) {
  const toRgb = (h) => [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)];
  const [r1, g1, b1] = toRgb(hex1);
  const [r2, g2, b2] = toRgb(hex2);
  const mix = (a, b) => Math.round(a + (b - a) * t);
  return `#${[mix(r1, r2), mix(g1, g2), mix(b1, b2)].map((v) => v.toString(16).padStart(2, "0")).join("")}`;
}

export function getModaliteColor(modalite) {
  const m = (modalite || "").toLowerCase();
  if (m.includes("sec")) return "#cc1100";
  if (m.includes("irrig")) return "steelblue";
  const match = m.match(/(\d+)/);
  const n = match ? parseInt(match[1], 10) : 3;
  const maxN = 5;
  const t = maxN > 1 ? (n - 1) / (maxN - 1) : 0;
  return hexMix("#E6D6F2", "#3B0A5C", Math.min(1, Math.max(0, t)));
}

// ⚠️ Correspondance de libellés provisoire (à ajuster) — les valeurs à
// gauche (Mais1, Mais2...) sont celles renvoyées telles quelles par l'API
// dans le champ "modalite" ; les valeurs à droite sont juste le texte
// affiché côté front, change-les librement selon ce que ça représente
// vraiment (Mais1 = restriction la plus rare ? la plus stricte ? à confirmer).
export const LABELS_POL = {
  MaisSec: "Sec",
  MaisFullIrrig: "Irrigué 100%",
  Mais1: "Rare",
  Mais2: "Faible",
  Mais3: "Moyenne",
  Mais4: "Stricte",
  Mais5: "Radicale",
};

export const ALEAS = ["CDF", "Gel", "CDC", "SHRU", "EE"];
export const ALEAS_PERTES = ["Gel", "CDC", "EE", "SHRU", "CDF", "Total"];
export const NIVEAUX_RISQUE = [
  "Tres courant",
  "Courant",
  "Exceptionnel",
  "Catastrophique",
  "Extreme",
  "Moyen",
];

export const RCP_OPTIONS = [
  { value: "4.5", label: "RCP 4.5" },
  { value: "8.5", label: "RCP 8.5" },
  { value: "hybride", label: "Hybride 4.5→8.5" },
];

export const HORIZON_COLORS = { 2020: "#6FFF6F", 2035: "#CB86EA", 2050: "#FF6969" };
export const YEAR_COLORS = { 2020: "#6FFF6F", 2035: "#CB86EA", 2050: "#FF6969" };

export const TABS = [
  { id: "phenologie", label: "Phénologie" },
  { id: "aleas", label: "Aléas" },
  { id: "pertes", label: "Impacts" },
  { id: "eau", label: "Eau" },
  { id: "marge", label: "Marge" },
  { id: "subvention", label: "Subvention" },
  { id: "territoire", label: "Territoire" },
  { id: "economie", label: "Économie" },
];

export const ALEA_INFO = {
  Gel:  { label: "Gel",              color: "#00E57D" },
  CDF:  { label: "Coup de froid",     color: "#9923E0" },
  CDC:  { label: "Coup de chaleur",   color: "#FF9900" },
  EE:   { label: "Excès d'eau",       color: "#012FF1" },
  SHRU: { label: "Stress hydrique",   color: "#00F1F1" },
};

export const EQUIPEMENTS = [
  { value: "enrouleur", label: "Enrouleur" },
  { value: "pivot", label: "Pivot" },
  { value: "rampe", label: "Rampe" },
  { value: "gag", label: "Goutte-à-Goutte" },
];